// Only run the calculator if the element exists on the page
if (document.querySelector("dimension-calculator")) {
  class DimensionCalculator extends HTMLElement {
    constructor() {
      super();
      this.initialPrice = parseFloat(this.getAttribute("initial-price")) || 0;
      this.currencyCode = this.getAttribute("currency-code") || "USD";
    }

    connectedCallback() {
      console.log("[Calculator] Connected, initializing...");
      this.init();
    }

    init() {
      const widthFt = this.querySelector("#width-ft");
      const widthIn = this.querySelector("#width-in");
      const heightFt = this.querySelector("#height-ft");
      const heightIn = this.querySelector("#height-in");
      const totalAreaDisplay = this.querySelector("#total-area-display");
      const totalPriceDisplay = this.querySelector("#total-price-display");

      let productForm = this.closest("form");
      if (!productForm || !productForm.querySelector('button[type="submit"]')) {
        productForm = document.querySelector(
          'form[action*="/cart/add"]:has(button[type="submit"])'
        );
      }

      if (
        !widthFt ||
        !widthIn ||
        !heightFt ||
        !heightIn ||
        !totalAreaDisplay ||
        !totalPriceDisplay ||
        !productForm
      ) {
        console.warn("[Calculator] Missing form or input elements");
        return;
      }

      console.log(
        "[Calculator] All input elements found, using form:",
        productForm
      );

      const calculate = () => {
        const width =
          (parseFloat(widthFt.value) || 0) +
          (parseFloat(widthIn.value) || 0) / 12;
        const height =
          (parseFloat(heightFt.value) || 0) +
          (parseFloat(heightIn.value) || 0) / 12;
        const totalSqFt = parseFloat((width * height).toFixed(2));
        const unitPrice = this.initialPrice / 100;
        const totalPrice = totalSqFt * unitPrice;

        console.log(
          `[Calculator] Width: ${width}, Height: ${height}, Area: ${totalSqFt}, Price: ${totalPrice}`
        );

        totalAreaDisplay.textContent = totalSqFt.toFixed(2);
        totalPriceDisplay.textContent = `$ ${totalPrice.toLocaleString(
          undefined,
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }
        )}`;

        // Ensure quantity input
        let quantityInput = productForm.querySelector('[name="quantity"]');
        if (!quantityInput) {
          quantityInput = document.createElement("input");
          quantityInput.type = "hidden";
          quantityInput.name = "quantity";
          productForm.appendChild(quantityInput);
          console.log("[Calculator] Injected hidden quantity input");
        }
        quantityInput.value = Math.max(1, Math.ceil(totalSqFt));

        // Inject cart properties
        const props = [
          ["properties[Width]", `${width.toFixed(2)} ft`],
          ["properties[Height]", `${height.toFixed(2)} ft`],
          ["properties[Total]", `${totalSqFt.toFixed(2)} sq ft`],
        ];
        props.forEach(([name, value]) => {
          let input = productForm.querySelector(`input[name="${name}"]`);
          if (!input) {
            input = document.createElement("input");
            input.type = "hidden";
            input.name = name;
            productForm.appendChild(input);
          }
          input.value = value;
        });
      };

      [widthFt, widthIn, heightFt, heightIn].forEach((input) => {
        input.addEventListener("input", () => {
          console.log("[Calculator] Input changed");
          calculate();
        });
      });

      calculate();
    }
  }

  if (!customElements.get("dimension-calculator")) {
    customElements.define("dimension-calculator", DimensionCalculator);
  } else {
    console.warn("[Calculator] Already defined — skipping re-register");
  }
} else {
  console.log("[Calculator] Not on product page — skipping init");
}
